import * as React from 'react';
import './loading.css';
const image = process.env.PUBLIC_URL + '/assets/img/Loading.gif';

export const Loading = () => (
  <div className="loading-shading">
    <div className="loading-icon">
      <img src={process.env.PUBLIC_URL + "/assets/img/Loading.gif"} className="loading" />
    </div>
  </div>
);
